/**
 * 描述：请求封装
 * 作者：猪不乐意
 * 日期：2019年10月4日
 */

import axios from 'axios'
import qs from 'qs'
import router from "../src/router"
import { Message ,Loading } from 'element-ui';

// 引入配置文件
import baseConfig from '../config/config.base'

// 开启cookie跨域验证session信息 jimmy
axios.defaults.withCredentials = true

// 创建一个请求对象
let axiosX = axios.create({
  baseURL: baseConfig.WWW_API_URL
})
let loadingRequestCount = 0;
const showLoading = () => {
  if (loadingRequestCount === 0) {
         // element的服务方式 target 我这边取的是表格 项目是后台系统 每个页面都有表格 类似整个表格loading
            //和在表格配置v-loading一样的效果，这么做是全局实现了，不用每个页面单独去v-loading
     Loading.service({ fullscreen: true });
  }
  loadingRequestCount++
}
const hideLoading = () => {
  if (loadingRequestCount <= 0) return
  loadingRequestCount--
  if (loadingRequestCount === 0) {
      
        Loading.service({ fullscreen: true }).close();
      
  }
}
// request 拦截
axiosX.interceptors.request.use(
  config => {
    // Loading.service({ fullscreen: true });
    showLoading(config)
    if (process.client&&window.localStorage.getItem('token')) {
      config.headers.Token = window.localStorage.getItem('token')
    }
    return config
  },
  err => {
    // Loading.service({ fullscreen: true }).close();
    return Promise.reject(err)
  }
)

// response 拦截
axiosX.interceptors.response.use(
  response => {
    // Loading.service({ fullscreen: true }).close();
    setTimeout(() => {
      hideLoading()
  }, 200);
    const code = response.data.code
    // 如果未返回 body 体
    // if (!response.data) {
    //   // Message.error('系统繁忙！请稍后再试！')
    // }
   // 如果登录信息失效
    if (code === 401) {
      Message.error('登录信息失效')
      localStorage.clear()
      // localStorage.removeItem('token')
      router.push('/login')
      // loadingInstance.close();
    }
    if (code === 408) {
      router.push('/datuminfo')
    }
    //成功则直接返回数据
    return response.data
  },
  error => {
    setTimeout(() => {
      hideLoading()
   }, 200);
    // Loading.service({ fullscreen: true }).close();
    // // 如果服务器返回500错误
    if (error.response && error.response.status ===500) {
      //  router.replace({
      //    path:"/login"
      //  })
      // redirect('/error')
      // Message.error()
    }
    return Promise.reject(error)
  }
)

/**
 * @param {string}  method   请求方法
 * @param {string}  url      请求地址
 * @param {Object}  params    请求参数
 * @param {Boolean} loading  loading 状态
 * @param {Boolean} stringify 是否格式化参数
 */
function XHR (url, { method = 'get', params = {}, loading = false, stringify = true,  options = {} }) {
  // 格式化参数
  let fromData = params
  // 如果开启格式参数，且请求为 post
  if (method === 'post' && stringify) {
    fromData = qs.stringify(fromData)
  }
  //启用loading
  // if (loading) Loading.service(options);
  // let loadingInstance = Loading.service(options);
  // // 返回结果
  // return new Promise((resolve, reject) => {
  //   axiosX[method](url, fromData, options).then(res => {
  //     if (process.client) loadingInstance.close()
  //     resolve(res)
  //   }).catch(error => {
  //     if (process.client) loadingInstance.close();
  //     reject(error)
  //   })
  // })
  
}

/**
 * GET 请求
 * @param {String} url 地址
 * @param {Object} params 参数
 * @param {Boolean} loading 加载状态，默认开启
 * @param {Object} options 请求头设置
 */
export function axiosGet (url, params, loading = false, options) {
  return XHR(url, { method: 'get', params, loading, options })
}

/**
 * POST 请求
 * @param {String} url 地址
 * @param {Object} params 参数
 * @param {Boolean} loading 加载状态，默认开启
 * @param {Boolean} stringify 是否格式化参数
 * @param {Object} options 请求头设置
 */
export function axiosPost (url, params, loading = false, stringify = true, options) {
  return XHR(url, { method: 'post', params, loading, options, stringify })
}

/**
 * delete 请求
 * @param {String} url 地址
 * @param {Object} params 参数
 * @param {Boolean} loading 加载状态，默认开启
 * @param {Boolean} stringify 是否格式化参数
 * @param {Object} options 请求头设置
 */
export function axiosDelete (url, params, loading = false, stringify = true, options) {
  return XHR(url, { method: 'delete', params, loading, options, stringify })
}

export default function (Vue) {
  // 注入未封装的原始请求
  Vue.prototype.$axios = axiosX
  // 注入封装好的请求
  Vue.prototype.$http = {
    get: axiosGet,
    post: axiosPost,
    delete: axiosDelete
  }
}



//////////////////
// WEBPACK FOOTER
// ./utils/axios.js
// module id = bhTA
// module chunks = 19